exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icoEdit{\r\n    position: absolute;\r\n    bottom: 10px;\r\n    width: 50px;\r\n    height: 50px;\r\n    right: -20px;\r\n    background: #834495 !important;\r\n    color: #fff !important;\r\n}\r\n.icoEdit i {\r\n    color: rgba(255, 255, 255, 0.8) !important;\r\n    line-height: 3 !important;\r\n    font-size: 1.3em !important;\r\n}\r\n\r\n.img-wrap {\r\n    position: relative;\r\n    max-width: 200px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/admins/manage-admin/manage-admin.component.css
// module id = ../../../../../src/app/users/admins/manage-admin/manage-admin.component.css
// module chunks = main